import { createI18n } from "vue-i18n";
import messages from './translation';
import messages_vip from './translation-vip';

// 合并翻译消息
const mergedMessages = {};
for (const locale in messages) {
  const vipMessagesWithPrefix = {};
  if (messages_vip[locale]) {
    vipMessagesWithPrefix["vip"] = {
      ...messages_vip[locale],
    };
  }

  mergedMessages[locale] = {
    ...messages[locale],
    ...vipMessagesWithPrefix,
  };
}

// 创建 VueI18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: localStorage.getItem("preferred_lang") || "en",
  fallbackLocale: "en",
  messages: mergedMessages,
});

// 设置语言
export const setLanguage = (lang) => {
  i18n.global.locale.value = lang;
  localStorage.setItem("preferred_lang", lang);
};
// 获取当前语言
export const getLanguage = () => {
  return i18n.global.locale.value;
};

export default i18n;